module.exports = __webpack_public_path__ + "img/stem.12397b7f.svg";